module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      "close": _vm.closeCallBack
    }
  }, [_c('el-form', {
    ref: "ruleform",
    attrs: {
      "label-width": "100px",
      "model": _vm.form,
      "rules": _vm.rules
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "幼儿园名称",
      "prop": "SchoolName",
      "required": ""
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.SchoolName),
      callback: function($$v) {
        _vm.$set(_vm.form, "SchoolName", $$v)
      },
      expression: "form.SchoolName"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "园长名称",
      "prop": "PrincipalName",
      "required": ""
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.PrincipalName),
      callback: function($$v) {
        _vm.$set(_vm.form, "PrincipalName", $$v)
      },
      expression: "form.PrincipalName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('areaSelect', {
    ref: "area",
    attrs: {
      "value": _vm.address,
      "required": "",
      "label-width": "100px"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "详细地址",
      "prop": "Address",
      "required": ""
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.Address),
      callback: function($$v) {
        _vm.$set(_vm.form, "Address", $$v)
      },
      expression: "form.Address"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": "所属代理商",
      "prop": "AgentId",
      "required": ""
    }
  }, [_c('el-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.agentVisible),
      expression: "agentVisible"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择或搜索",
      "disabled": !_vm.opts.isFormEidt,
      "filterable": ""
    },
    model: {
      value: (_vm.form.AgentId),
      callback: function($$v) {
        _vm.$set(_vm.form, "AgentId", $$v)
      },
      expression: "form.AgentId"
    }
  }, _vm._l((_vm.AgentList), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.Customer,
        "value": item.Id
      }
    })
  }))], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "园长电话",
      "prop": "PhoneNo",
      "required": ""
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.PhoneNo),
      callback: function($$v) {
        _vm.$set(_vm.form, "PhoneNo", $$v)
      },
      expression: "form.PhoneNo"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "园所电话",
      "prop": "AddPhoneNo",
      "required": ""
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.AddPhoneNo),
      callback: function($$v) {
        _vm.$set(_vm.form, "AddPhoneNo", $$v)
      },
      expression: "form.AddPhoneNo"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Email"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.Email),
      callback: function($$v) {
        _vm.$set(_vm.form, "Email", $$v)
      },
      expression: "form.Email"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "QQ2"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.QQ),
      callback: function($$v) {
        _vm.$set(_vm.form, "QQ", $$v)
      },
      expression: "form.QQ"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "微信"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.Weixin),
      callback: function($$v) {
        _vm.$set(_vm.form, "Weixin", $$v)
      },
      expression: "form.Weixin"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "数据类型",
      "required": ""
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.DataType),
      callback: function($$v) {
        _vm.$set(_vm.form, "DataType", $$v)
      },
      expression: "form.DataType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("测试")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("正式")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.SubjectList.length),
      expression: "SubjectList.length"
    }],
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "项目类型",
      "required": ""
    }
  }, [_c('el-checkbox-group', {
    on: {
      "change": _vm.changeProjectType
    },
    model: {
      value: (_vm.ProjectType),
      callback: function($$v) {
        _vm.ProjectType = $$v
      },
      expression: "ProjectType"
    }
  }, _vm._l((_vm.SubjectList), function(item) {
    return _c('el-checkbox', {
      attrs: {
        "disabled": !_vm.opts.isFormEidt,
        "label": item.ProjectTypeId
      }
    }, [_vm._v(_vm._s(item.ProjectTypeName))])
  }))], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.PolicyList.length),
      expression: "PolicyList.length"
    }],
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "政策类型"
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.PolicyType),
      callback: function($$v) {
        _vm.PolicyType = $$v
      },
      expression: "PolicyType"
    }
  }, _vm._l((_vm.PolicyList), function(item) {
    return _c('el-checkbox', {
      attrs: {
        "label": item.PolicyTypeId
      }
    }, [_vm._v(_vm._s(item.PolicyTypeName))])
  }))], 1)], 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("关 闭")]), _vm._v(" "), (_vm.isAdd) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addfn
    }
  }, [_vm._v("确 定")]) : _vm._e(), _vm._v(" "), (_vm.isUpdate) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.updatefn
    }
  }, [_vm._v("确 定")]) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-349f5990!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/school/components/schoolDetails.vue
// module id = 1445
// module chunks = 1